import {Button} from "@mui/material";

const DinoIconButton = ({icon, text, onClick, theme, disabled = false, style}) => {
    return <Button style={style} disabled={disabled} variant="contained" theme={theme} startIcon={icon} onClick={onClick}>{text}</Button>;
}

export default DinoIconButton